/**
 * Fehlerklasse für Fehler beim Erzeugen eines SPKI-Fingerprints.
 *
 * Drei klar unterscheidbare Fehlerarten, damit aufrufende Komponenten
 * (Pinning-Gate im Frontend, Konfigurations-Validation im Backend) ohne
 * Stringvergleich auf den Grund reagieren können.
 *
 * @see tickets/EPIC-001-patient-terminabsage/AFO-002-shared-vertrag/afo.md
 */

/**
 * Diskriminator für `FingerprintError`.
 * - `INVALID_BASE64`: Eingabe-String ist kein gültiges Standard-Base64.
 * - `KEY_IMPORT_FAILED`: WebCrypto konnte den SPKI nicht als RSA-OAEP-Schlüssel laden.
 * - `KEY_TOO_WEAK`: Schlüssel ist syntaktisch valide, aber Modulus < 3072 Bit.
 */
export type FingerprintErrorKind = 'INVALID_BASE64' | 'KEY_IMPORT_FAILED' | 'KEY_TOO_WEAK';

/**
 * Fehler beim Erzeugen eines SPKI-Fingerprints.
 *
 * Das `kind`-Feld ist ein Discriminated-Union-Tag und der primäre
 * Vergleichspunkt für aufrufende Stellen — die `message` ist nur für Logs.
 */
export class FingerprintError extends Error {
  public readonly kind: FingerprintErrorKind;

  public constructor(kind: FingerprintErrorKind, message: string) {
    super(message);
    this.name = 'FingerprintError';
    this.kind = kind;
  }
}
